export default "__VITE_ASSET__34844cff__"